const state = {
  newProjectModal: false,
  modalData: [],
  newThreadModal: false,
  previewFileModal: false,
  fileModalData: {}
};

const mutations = {
  SET_PREVIEWMODAL_FILE(state, data) {
    state.previewFileModal = data;
  },
  SET_FILEMODAL_DATA(state, data) {
    state.fileModalData = data;
  }
};

export default {
  namespaced: true,
  state,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/modal.js